import type { SVGProps } from 'react'

const ChevronRight = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.1535 17.2969" {...props}>
        <path d="M12.1535 8.64355C12.15 8.31152 12.026 8.02539 11.7631 7.77227L4.15701 0.3207C3.93553 0.107226 3.67147 0 3.35253 0C2.72441 0 2.21953 0.493355 2.21953 1.12772C2.21953 1.4369 2.34531 1.72303 2.56308 1.9453L9.42989 8.64179L2.56308 15.3418C2.34707 15.5623 2.21953 15.8422 2.21953 16.1611C2.21953 16.7937 2.72441 17.2889 3.35253 17.2889C3.66795 17.2889 3.93553 17.1816 4.15701 16.9601L11.7631 9.51483C12.0277 9.2537 12.1535 8.97382 12.1535 8.64355Z" />
    </svg>
)
export default ChevronRight
